import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconWarningAlarmDeleteError = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24h-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M18.5 16.632l2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M21 16.632l-2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M12.5 12.067v-3.067"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M12.5 15.676l4.71877e-09 3.69482e-13c-.0883656-6.90644e-06-.160006.0716219-.160013.159987 -5.24323e-08.000670853 4.1143e-06.0013417 1.24999e-05.0020125l-5.6186e-09-9.42228e-07c.000527326.0884745.071538.160374.159999.162001l7.25196e-09-1.77636e-15c.0894701-6.75481e-09.162-.0725299.162-.162 -6.75481e-09-.0894701-.0725299-.162-.162-.162"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M20.546 13.518l-4.727-8.118 -9.54682e-08-1.63228e-07c-1.0721-1.83303-3.42717-2.44989-5.2602-1.3778 -.569948.333348-1.04445.807851-1.3778 1.3778l-5.7 9.778 4.33977e-08-7.46568e-08c-.983097 1.69122-.409054 3.85917 1.28216 4.84227 .546402.317622 1.16784.483259 1.79984.479729h8.973"
  })));
};
//# sourceMappingURL=IconWarningAlarmDeleteError.js.map